/**
 * @param {any} $scope
 */
const KformBuilderOptionPathController = /* @ngInject */ $scope => {
	$scope.options = {
		display: 'tree',
		mode:    'class',
	};

	$scope.updatePath = () => {
		if (!Array.isArray($scope.component.kdata.path)) {
			$scope.component.kdata.path = [];
		}
		$scope.component.kdata.path.length = 0;

		if (Array.isArray($scope.formComponentPath)) {
			$scope.component.kdata.path.push(...$scope.formComponentPath.map((/** @type {any} */ p) => ({
				kid:        p.kid,
				flow:       p.flow,
				linker_kid: p.linker_kid,
			})));
		}
	};
};

export default KformBuilderOptionPathController;
